/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext, useState } from 'react';
import { DiskContext } from '../context';
import { useForm } from 'react-hook-form';
import { DiskDirectoryTree } from '../directory-tree';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const DiskCopyMultipleFilesModal = forwardRef(({ ...props }, ref) => {
  const [selected, setSelected] = useState();
  const {
    copyMultipleFileFolder,
    selectedFiles,
    multiCopyDisc,
    copyMultipleFileFolderLoading,
  } = useContext(DiskContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = () => {
    const ids = selectedFiles;
    copyMultipleFileFolder({ ids, parent: selected?.id, team_id: selected?.team_info?.id });
  };
  const { t } = useTranslator();
  return (
    <>
      <Modal size="2xl" {...multiCopyDisc}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalCloseButton />
            <ModalHeader>
              <Text truncate maxW="64">
                {t('myDisk.copyFilesHere') || "Copy files here to"}...
              </Text>
            </ModalHeader>
            <ModalBody maxH="70vh" overflowY="auto">
              <DiskDirectoryTree setSelectedItem={setSelected} />
            </ModalBody>
            <ModalFooter>
              <Button
                borderRadius="full"
                isLoading={copyMultipleFileFolderLoading}
                type="submit"
                variant="primary"
              >
                {t('myDisk.copy') || "Copy"}
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
});
